import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, X, ArrowLeft, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

// ONE-EV Reference Projects
const referenceImages = [
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/tx4ny4a8_00000922-PHOTO-2024-06-05-15-04-39.jpg',
    title: 'Ladestation Installation - Baustelle'
  },
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/15s92y06_00001026-PHOTO-2023-07-03-11-47-39.jpg',
    title: 'Fundamentarbeiten und Installation'
  },
  {
    id: 3,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/jru0eiyg_00002349-PHOTO-2024-08-14-18-52-52.jpg',
    title: 'Fertige Ladestation Anlage'
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/fj4qigym_1743247527655.jpeg',
    title: 'Ladeinfrastruktur am Straßenrand'
  },
  {
    id: 5,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/hio016sr_DJI_0433.JPG',
    title: 'E-Parkplatz Luftaufnahme'
  },
  {
    id: 6,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/lrvcreaw_PHOTO-2025-01-16-09-47-06%202.jpg',
    title: 'Große Ladestation Anlage - Luftaufnahme'
  },
  {
    id: 7,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/wjtyzw33_PHOTO-2025-03-14-17-30-59.jpg',
    title: 'TotalEnergies Schnellladestation'
  },
  {
    id: 8,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/n36wifqd_PHOTO-2025-10-24-10-02-36.jpg',
    title: 'Elektrotechnik - Kabelverbindungen'
  },
  {
    id: 9,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/qi2dhsxz_PHOTO-2025-10-25-13-45-50.jpg',
    title: 'Elektroinstallation - Anschlüsse Detail'
  },
  {
    id: 10,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/jvnmjedl_PHOTO-2025-10-25-13-45-51.jpg',
    title: 'Schaltschrank und Elektroarbeiten'
  },
  {
    id: 11,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/ccayhwhb_PHOTO-2025-12-06-11-42-25.jpg',
    title: 'Bodeninstallation - Kabelanschluss'
  },
  {
    id: 12,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/oar5nlqu_PHOTO-2026-03-26-12-16-50.jpg',
    title: 'Baustelle Luftaufnahme - Infrastruktur'
  },
  {
    id: 13,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/cwg11zan_WhatsApp%20Image%202025-01-17%20at%2010.34.57.jpeg',
    title: 'Einkaufszentrum Parkplatz - Installation'
  },
  {
    id: 14,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/13w3wpej_WhatsApp%20Image%202025-03-11%20at%2015.10.10.jpeg',
    title: 'Eliso Schnellladestation Installation'
  },
  {
    id: 15,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/byeiuprd_WhatsApp%20Image%202025-05-14%20at%2009.25.51.jpeg',
    title: 'Eliso Ladestation - Fertigstellung'
  },
  {
    id: 16,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/tu2khrzv_PHOTO-2026-03-26-12-48-17.jpg',
    title: 'Transformatorstation - Installation'
  },
  {
    id: 17,
    url: 'https://customer-assets.emergentagent.com/job_site-remake-8/artifacts/1e312ena_PHOTO-2026-03-26-12-47-50.jpg',
    title: 'Ladesäulen Montage - Baustelle'
  }
];

const ReferencesPage = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % referenceImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => 
      prev === 0 ? referenceImages.length - 1 : prev - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="py-6 px-6 border-b border-gray-300 bg-white">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            className="flex items-center gap-2 hover:text-[#FF5722] transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
            Zurück
          </Button>
          <h1 className="text-2xl md:text-3xl font-bold">
            <span className="text-[#FF5722]">Unsere</span>{' '}
            <span className="text-black">Referenzen</span>
          </h1>
          <div className="w-24"></div>
        </div>
      </header>

      {/* Main Slider */}
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-6xl w-full">
          {/* Slider Container */}
          <div className="relative aspect-video bg-white rounded-lg shadow-2xl overflow-hidden group">
            {/* Image */}
            <img
              src={referenceImages[currentIndex].url}
              alt={referenceImages[currentIndex].title}
              className="w-full h-full object-cover cursor-pointer transition-transform duration-300 hover:scale-105"
              onClick={toggleFullscreen}
            />

            {/* Navigation Arrows */}
            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-300 opacity-0 group-hover:opacity-100"
              aria-label="Vorheriges Bild"
            >
              <ChevronLeft className="h-6 w-6" />
            </button>

            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-300 opacity-0 group-hover:opacity-100"
              aria-label="Nächstes Bild"
            >
              <ChevronRight className="h-6 w-6" />
            </button>

            {/* Image Counter */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 text-white px-4 py-2 rounded-full text-sm font-medium">
              {currentIndex + 1} / {referenceImages.length}
            </div>
          </div>

          {/* Thumbnail Navigation */}
          <div className="flex gap-4 justify-center mt-6 flex-wrap">
            {referenceImages.map((image, index) => (
              <button
                key={image.id}
                onClick={() => goToSlide(index)}
                className={`relative w-20 h-20 rounded-lg overflow-hidden transition-all duration-300 ${
                  index === currentIndex
                    ? 'ring-4 ring-[#FF5722] scale-110'
                    : 'ring-2 ring-gray-300 hover:ring-[#FF5722] opacity-60 hover:opacity-100'
                }`}
              >
                <img
                  src={image.url}
                  alt={`Thumbnail ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>

          {/* Keyboard Navigation Hint */}
          <div className="text-center mt-8 text-gray-500 text-sm">
            Verwenden Sie die Pfeiltasten ← → zum Navigieren
          </div>
        </div>
      </main>

      {/* Fullscreen Modal */}
      {isFullscreen && (
        <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">
          <button
            onClick={toggleFullscreen}
            className="absolute top-4 right-4 text-white hover:text-[#FF5722] transition-colors z-10"
            aria-label="Vollbild schließen"
          >
            <X className="h-8 w-8" />
          </button>

          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-4 rounded-full transition-all"
            aria-label="Vorheriges Bild"
          >
            <ChevronLeft className="h-8 w-8" />
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-4 rounded-full transition-all"
            aria-label="Nächstes Bild"
          >
            <ChevronRight className="h-8 w-8" />
          </button>

          <img
            src={referenceImages[currentIndex].url}
            alt={referenceImages[currentIndex].title}
            className="max-w-[90%] max-h-[90%] object-contain"
          />

          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 bg-white/20 text-white px-6 py-3 rounded-full text-lg font-medium">
            {currentIndex + 1} / {referenceImages.length}
          </div>
        </div>
      )}
      
      {/* Footer */}
      <footer className="py-8 px-6 border-t border-gray-300 bg-white mt-auto">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-600">
            {/* Copyright */}
            <div className="text-center md:text-left">
              <p>© 2026 ONE-EV GmbH. Alle Rechte vorbehalten.</p>
            </div>

            {/* Contact Email */}
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4" />
              <a 
                href="mailto:info@one-ev.de" 
                className="hover:text-[#FF5722] transition-colors duration-200"
              >
                info@one-ev.de
              </a>
            </div>
          </div>

          {/* Impressum */}
          <div className="mt-4 text-xs text-gray-500 text-center md:text-left">
            <p>
              <span className="font-semibold">IMPRESSUM:</span> ONE-EV GmbH | Celiusstraße 2, D-14532 Kleinmachnow | 
              Geschäftsführer: Jan Mikolajczak | Amtsgericht Potsdam, HRB 41680 P | USt.-Ident-Nr. DE660224399
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ReferencesPage;